import VueI18n from '@/i18n/locale';

export default [
  {
    path: '/general/message-center/manage',
    name: '/general/message-center/manage',
    async component(resolve) {
      resolve(await import('../pages/back-stage/manage.vue'));
    },
    meta: {
      title: VueI18n.t('Gattaran_MSGCenter__XIYn' /** 消息配置 */),
      matchedKeys: ['/sys-side', '/general/message-center/manage'],
    },
  },
  {
    path: '/general/message-center/survey',
    name: '/general/message-center/survey',
    async component(resolve) {
      resolve(await import('../pages/survey-center/pages/manage.vue'));
    },
    meta: {
      title: VueI18n.t('Gattaran_20240401_ycgC_XryN' /** 调研中心 */),
      matchedKeys: ['/sys-side', '/general/message-center/survey'],
    },
  },
  {
    path: '/general/message-center/survey/create',
    name: '/general/message-center/survey/create',
    async component(resolve) {
      resolve(await import('../pages/survey-center/pages/create.vue'));
    },
    meta: {
      title: VueI18n.t('Gattaran_20240401_vCtD_sEvO' /** 新建调研问卷 */),
      matchedKeys: ['/sys-side', '/general/message-center/survey'],
    },
  },
];
